var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"qrCodeDiv",staticStyle:{"width":"380px","height":"380px"},attrs:{"id":"qrCode"}})}
var staticRenderFns = []

export { render, staticRenderFns }